import { ReactNode } from "react";
import { Link } from "react-router-dom";

interface AuthLayoutProps {
  children: ReactNode;
  headerActions?: ReactNode;
  showFooter?: boolean;
}

export default function AuthLayout({ children, headerActions, showFooter = true }: AuthLayoutProps) {
  return (
    // The sign-in pages swap bonni's orange accent for the Router page's Bizly
    // purple (#310062, hover #2A0454) by overriding the token for this subtree
    // only; tokens.css and the signed-in app keep the orange.
    <div className="min-h-screen bg-surface-base flex flex-col [--accent-primary:270_100%_19.2%] [--accent-primary-hover:268.5_90.9%_17.3%]">
      <header className="w-full">
        <div className="w-full px-6 py-6 flex items-center justify-between">
          {/* The sign-in pages carry Bizly's logo to match the Router landing
              page; the signed-in app's header keeps the bonni Logo. */}
          <a href="/" className="flex h-8 items-center select-none">
            <img
              src="/assets/bizly-wordmark.png"
              alt="Bizly"
              width={227}
              height={84}
              className="h-[26px] w-auto"
            />
          </a>
          {headerActions ? <div className="flex items-center gap-2">{headerActions}</div> : null}
        </div>
      </header>

      <main className="mx-auto max-w-[1060px] px-6 flex-1 w-full flex items-center justify-center">
        <div className="w-full flex-shrink-0">{children}</div>
      </main>

      {showFooter ? (
        <footer className="mx-auto mt-16 mb-8 flex w-full max-w-[1060px] flex-col items-stretch gap-4 sm:flex-row sm:items-center sm:justify-between px-6">
          <p className="text-sm font-medium text-text-muted">
            © {new Date().getFullYear()} Bizly, Inc. All rights reserved.
          </p>

          <div className="flex items-center gap-2">
            <Link to="/privacy-policy" className="text-sm font-semibold text-text-primary hover:opacity-80">
              Privacy Policy
            </Link>
            <span className="inline-block h-1 w-1 rounded-full bg-border-strong"></span>
            <a href="https://b2.bizly.com/terms" className="text-sm font-semibold text-text-primary hover:opacity-80">
              Terms & Conditions
            </a>
          </div>
        </footer>
      ) : null}
    </div>
  );
}
